/// Port of mobile/lib/core/ui/snackbar/ui/pixel_snack_bar.dart.

import type { AppSnack } from './snackbarStore';
import { PixelContainer } from '@/ui/pixel/PixelContainer';
import { PixelIcon } from '@/ui/pixel/PixelIcon';

const maxWidth = 420;
const onFill = '#F5F5F5';

const fills = {
  success: '#1B7F3A',
  error: '#C62828',
  info: '#37474F',
} as const;

export function PixelSnackBar({
  snack,
  onDismiss,
}: {
  snack: AppSnack;
  onDismiss: () => void;
}) {
  const fill = fills[snack.kind];
  const icon = snack.kind === 'success' ? 'check' : 'close';

  return (
    <div className="pointer-events-auto w-full px-4 pt-3" style={{ maxWidth }}>
      <PixelContainer
        radius={3}
        pixelScale={2}
        padding="12px 14px"
        backgroundColor={fill}
        borderColor={fill}
        onClick={onDismiss}
      >
        <div className="flex items-center gap-3">
          <PixelIcon name={icon} set="pixel_icons" size={22} color={onFill} />
          <span className="min-w-0 flex-1 leading-snug" style={{ fontSize: 20, color: onFill }}>
            {snack.message}
          </span>
        </div>
      </PixelContainer>
    </div>
  );
}
